import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CollapsibleCard } from '@routific/hive';
import Checkbox from '../../../shared/Checkbox';
import ColumnGrid from './ColumnGrid';
import { ExportColumnGroupData } from './types';

interface Props {
  groupData: ExportColumnGroupData;
  selectedKeys: Set<string>;
  checked: boolean;
  indeterminate: boolean;
  onToggleGroup: () => void;
  onToggleColumn: (key: string) => void;
}

const ColumnGroupCard: React.FC<Props> = ({ groupData, selectedKeys, checked, indeterminate, onToggleGroup, onToggleColumn }) => {
  const { t } = useTranslation('components');
  const [expanded, setExpanded] = useState(false);
  const label = t(`downloadCSVModal.groups.${groupData.group}`);
  const groupId = `export-group-${groupData.group}`;

  return (
    <CollapsibleCard
      headerId={`${groupId}-header`}
      contentId={`${groupId}-content`}
      header={label}
      headerLeading={
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={onToggleGroup}
          inputProps={{ 'aria-label': label }}
          data-cy={groupId}
        />
      }
      expanded={expanded}
      onToggle={() => setExpanded((prev) => !prev)}
    >
      <ColumnGrid columns={groupData.columns} selectedKeys={selectedKeys} onToggle={onToggleColumn} />
    </CollapsibleCard>
  );
};

export default ColumnGroupCard;
